import React from 'react';

/** Ukrasna tribal traka (valovi + točke). */
export function MonestiqTribalBand() {
    return (
        <svg
            className="monestiq-tribal-band"
            viewBox="0 0 480 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
        >
            <path
                d="M0 16 Q30 2 60 16 T120 16 T180 16 T240 16 T300 16 T360 16 T420 16 T480 16"
                stroke="currentColor"
                strokeWidth="2.2"
                strokeLinecap="round"
                opacity="0.88"
            />
            <path
                d="M0 24 Q30 30 60 24 T120 24 T180 24 T240 24 T300 24 T360 24 T420 24 T480 24"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                opacity="0.4"
            />
            <circle cx="120" cy="16" r="3" fill="currentColor" opacity="0.45" />
            <circle cx="240" cy="16" r="3" fill="currentColor" opacity="0.45" />
            <circle cx="360" cy="16" r="3" fill="currentColor" opacity="0.45" />
        </svg>
    );
}

/** Jednostavan crtež bankomata (outline). */
export function MonestiqAtmDrawing() {
    return (
        <svg
            className="monestiq-atm-drawing"
            viewBox="0 0 180 240"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
        >
            <ellipse cx="90" cy="228" rx="56" ry="7" fill="currentColor" fillOpacity="0.07" />
            <rect x="28" y="32" width="124" height="188" rx="14" stroke="currentColor" strokeWidth="3" />
            <path
                d="M22 32 L90 8 L158 32"
                stroke="currentColor"
                strokeWidth="2.8"
                strokeLinejoin="round"
                strokeLinecap="round"
            />
            <rect x="58" y="18" width="64" height="14" rx="3" stroke="currentColor" strokeWidth="2" opacity="0.75" />
            <rect x="46" y="52" width="88" height="52" rx="6" fill="currentColor" fillOpacity="0.08" stroke="currentColor" strokeWidth="2.2" />
            <circle cx="62" cy="128" r="5" fill="currentColor" fillOpacity="0.35" />
            <circle cx="90" cy="128" r="5" fill="currentColor" fillOpacity="0.35" />
            <circle cx="118" cy="128" r="5" fill="currentColor" fillOpacity="0.35" />
            <circle cx="62" cy="148" r="5" fill="currentColor" fillOpacity="0.35" />
            <circle cx="90" cy="148" r="5" fill="currentColor" fillOpacity="0.35" />
            <circle cx="118" cy="148" r="5" fill="currentColor" fillOpacity="0.35" />
            <circle cx="62" cy="168" r="5" fill="currentColor" fillOpacity="0.35" />
            <circle cx="90" cy="168" r="5" fill="currentColor" fillOpacity="0.35" />
            <circle cx="118" cy="168" r="5" fill="currentColor" fillOpacity="0.35" />
            <rect x="52" y="192" width="76" height="10" rx="2" stroke="currentColor" strokeWidth="2" fill="currentColor" fillOpacity="0.06" />
        </svg>
    );
}
